import { Outlet } from 'react-router-dom';
import { UIBox } from '@workspace/ui/composed';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';

/**
 * 통합 레이아웃 컴포넌트
 * 애플리케이션의 모든 레이아웃 기능을 단일 컴포넌트로 통합
 * - Header, Sidebar 포함
 * - 콘텐츠 영역 스타일링 (여백, 최대 너비 등)
 */
function MainLayout() {
  return (
    <UIBox className="flex flex-col h-screen">
      <Header />
      {/* 메인 컨텐츠 영역 컨테이너 */}
      <UIBox className="flex flex-1 pt-16 h-[calc(100vh-64px)]">
        {/* 사이드바 - 고정 너비 */}
        <UIBox className="w-[280px] shrink-0 border-r border-border">
          <Sidebar />
        </UIBox>

        {/* 메인 콘텐츠 영역 */}
        <main className="flex-1 overflow-auto p-4 sm:p-6 md:p-8 flex flex-col gap-6">
          <UIBox className="flex-1">
            <Outlet />
          </UIBox>
          <Footer />
        </main>
      </UIBox>
    </UIBox>
  );
}

export default MainLayout;
